<div class="location-based-rates" [formGroup]="rateCardForm">
  <div class="row rates">
    <h3>Rates</h3>
    <button mat-stroked-button color="primary" class="view-location-rates" (click)="openCreateLocation()">
      <mat-icon matPrefix>fullscreen</mat-icon>Full Screen
    </button>
  </div>

  <table class="rates-table">
    <thead class="rates-header">
      <tr class="header-row">
        <th class="location-header" rowspan="2">Location</th>
        <th colspan="2" class="unidil-header">Location Name</th>
      </tr>
      <tr class="subheader-row">
        <th class="distance-header">Distance</th>
        <th class="rate-header">Rate</th>
      </tr>
    </thead>
    <tbody class="rates-body" formArrayName="locationRates">
      <tr class="location-row disabled">
        <td class="location-cell" colspan="3" style="text-align: center;">Please click Full Screen button to see and edit</td>
      </tr>
    </tbody>
  </table>

  <div class="location-select">
    <div class="location-row">
      <div class="location-type">
        <h3>Apply the Location Rate</h3>
        <mat-form-field appearance="outline" class="hmt-form-field">
          <mat-select formControlName="locationApplyType" placeholder="Select" required>
            <mat-option value="FARTHEST">Farthest</mat-option>
            <mat-option value="NEAREST">Nearest</mat-option>
          </mat-select>
          <mat-error *ngIf="rateCardForm.get('locationApplyType').hasError('required')">
            Please select a location apply type
          </mat-error>
        </mat-form-field>
      </div>

      <div class="location-search">
        <form [formGroup]="locationForm">
          <mat-form-field class="hmt-form-field example-full-width" appearance="outline">
            <mat-label>Enter Location</mat-label>
            <input type="text"
                   placeholder="Enter Location"
                   aria-label="Location"
                   matInput
                   formControlName="locationForType"
                   [matAutocomplete]="auto"
                   (input)="onLocationForType($event)"
                   required>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayLocationName">
              <mat-option *ngFor="let option of filteredLocations" [value]="option">{{ option.locationName }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>

  <div class="location-conditions">
    <h4>For Every Location Before the Last</h4>
    
    <div class="condition-row">
      <div class="condition-label">Distance between the locations <=</div>
      <mat-form-field appearance="outline" class="hmt-form-field">
        <input matInput type="number" formControlName="distanceLessThan" placeholder="Distance"
               hmtRestrictInputDecimalPlaces decimalPlaces="2" required>
        <mat-error *ngIf="rateCardForm.get('distanceLessThan').hasError('required')">
          Distance is required
        </mat-error>
      </mat-form-field>
      <div class="unit">KM</div>
      <mat-form-field appearance="outline" class="hmt-form-field">
        <input matInput type="number" formControlName="rateLessThan" placeholder="Amount"
               hmtRestrictInputDecimalPlaces decimalPlaces="2" required>
        <mat-error *ngIf="rateCardForm.get('rateLessThan').hasError('required')">
          Rate is required
        </mat-error>
      </mat-form-field>
      <div class="unit">{{ currency }}</div>
    </div>

    <div class="condition-row">
      <div class="condition-label">Distance between the locations > </div>
      <mat-form-field appearance="outline" class="hmt-form-field">
        <input matInput type="number" formControlName="distanceGreaterThan" placeholder="Distance"
               hmtRestrictInputDecimalPlaces decimalPlaces="2" required>
        <mat-error *ngIf="rateCardForm.get('distanceGreaterThan').hasError('required')">
          Distance is required
        </mat-error>
      </mat-form-field>
      <div class="unit">KM</div>
      <mat-form-field appearance="outline" class="hmt-form-field">
        <input matInput type="number" formControlName="rateGreaterThan" placeholder="Amount"
               hmtRestrictInputDecimalPlaces decimalPlaces="2" required>
        <mat-error *ngIf="rateCardForm.get('rateGreaterThan').hasError('required')">
          Rate is required
        </mat-error>
      </mat-form-field>
      <div class="unit">{{ currency }}</div>
    </div>
  </div>
</div> 